// extracted by mini-css-extract-plugin
export default {"confirm":"style_confirm__R+FeZ","header":"style_header__JEGPQ","wrapper":"style_wrapper__zVkeQ","text":"style_text__zJeo3","button":"style_button__eTjb9"};